export default __webpack_public_path__ + "static/media/main.65507b2b.png";